var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroVisualWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 578,
    height: 578,
    viewBox: "0 0 578 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1720_114865)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.054 34.7394C458.468 62.6444 435.706 107.887 464.511 128.875C492.551 149.305 526.996 115.818 553.422 133.404C592.623 159.492 585.465 278.864 528.151 353.032C510.914 375.336 496.513 384.014 490.135 409.24C476.439 463.407 524.575 495.628 515.414 522.417C494.79 582.737 177.585 633.353 50.307 452.07C-9.14028 367.405 -18.033 245.146 35.0779 152.288C131.047 -15.5033 395.496 -27.8766 439.054 34.7394Z",
    fill: "#F6F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M444.444 539.903L357.883 509.129H494.227L444.444 539.903Z",
    fill: "#BFC1CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M438.59 530.106C420.85 530.106 403.281 524.77 399.349 518.187L382.025 489.2C373.128 474.312 348.41 462.201 308.29 462.201L288.794 461.848C213.251 461.848 138.166 439.042 121.414 411.011C104.662 382.98 152.491 360.174 228.034 360.174H424.686C464.806 360.174 490.209 348.063 481.31 333.175L478.432 328.361C469.535 313.474 429.656 301.362 389.536 301.362H192.884C117.341 301.362 42.2561 278.556 25.5043 250.525C8.75247 222.494 56.5814 199.688 132.124 199.688H328.776C368.897 199.688 444.59 187.577 435.693 172.689L409.558 128.955C405.623 122.372 416.816 117.036 434.554 117.036C452.292 117.036 469.863 122.372 473.796 128.955L499.932 172.689C516.683 200.72 418.562 223.526 343.021 223.526H146.369C106.249 223.526 80.8477 235.638 89.7446 250.525C98.6415 265.413 138.521 277.524 178.641 277.524H375.293C450.836 277.524 525.921 300.33 542.672 328.361L545.551 333.175C562.303 361.206 514.474 384.012 438.931 384.012H242.279C202.158 384.012 176.757 396.123 185.654 411.011C194.551 425.899 234.43 438.01 274.551 438.01L294.047 438.363C369.59 438.363 429.514 461.169 446.268 489.2L463.591 518.187C467.526 524.77 456.332 530.106 438.594 530.106H438.59Z",
    fill: "#BDBFC9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M485.035 69.2419H471.828V71.8368H485.035V69.2419Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M485.035 101.496H471.828V104.091H485.035V101.496Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M485.035 133.751H471.828V136.346H485.035V133.751Z",
    fill: "#BCC3CA"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M458.367 51.7002V207.785L437.344 203.054V66.5176L458.367 51.7002Z",
    fill: "#BCC3CA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M524.13 52.0693H458.367V207.783H524.13V52.0693Z",
    fill: "#D8DEE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 70.6064H470.226V95.0765H483.163V70.6064Z",
    fill: "#BCC3CA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M501.221 70.6064H488.014V95.0765H501.221V70.6064Z",
    fill: "#BCC3CA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M519.011 70.6064H506.074V95.0765H519.011V70.6064Z",
    fill: "#BCC3CA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 102.861H470.226V127.331H483.163V102.861Z",
    fill: "#BCC3CA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M501.221 102.861H488.014V127.331H501.221V102.861Z",
    fill: "#BCC3CA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M519.011 102.861H506.074V127.331H519.011V102.861Z",
    fill: "#BCC3CA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 135.117H470.226V159.587H483.163V135.117Z",
    fill: "#BCC3CA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M501.221 135.117H488.014V159.587H501.221V135.117Z",
    fill: "#BCC3CA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M519.011 135.117H506.074V159.587H519.011V135.117Z",
    fill: "#BCC3CA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 167.372H470.226V191.842H483.163V167.372Z",
    fill: "#BCC3CA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M501.221 167.372H488.014V191.842H501.221V167.372Z",
    fill: "#BCC3CA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M519.011 167.372H506.074V191.842H519.011V167.372Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 70.6064H470.226V73.2012H483.163V70.6064Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 102.861H470.226V105.456H483.163V102.861Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 135.117H470.226V137.712H483.163V135.117Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M483.163 167.372H470.226V169.967H483.163V167.372Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M524.132 205.2V207.784H458.369L437.346 203.053V179.948C438.753 175.02 440.451 170.223 442.467 166.259C450.194 151.058 447.677 144.877 449.294 133.755C450.912 122.633 447.318 62.3266 458.369 52.0671C468.7 69.2441 467.982 68.503 468.341 86.7946C468.532 96.5793 468.518 105.233 470.226 111.657C471.708 117.241 474.493 121.136 479.839 122.631C480.964 122.946 482.074 123.446 483.163 124.117C486.64 126.249 489.91 130.101 492.679 135.113C496.323 141.694 499.119 150.273 500.421 159.583C500.78 162.131 501.025 164.736 501.143 167.37C501.184 168.245 501.211 169.127 501.221 170.01C501.231 170.778 501.231 171.546 501.221 172.312C501.215 172.582 501.215 172.849 501.221 173.113C501.273 179.764 503.266 184.351 506.072 187.868C507.26 189.359 508.595 190.657 509.99 191.84C515.567 196.563 522.106 199.414 524.13 205.198L524.132 205.2Z",
    fill: "#BCC3CA"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M397.296 66.3477V181.056L378.967 177.582V77.2409L395.635 67.3344L397.085 66.4715L397.296 66.3477Z",
    fill: "#BCC3CA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M448.236 66.2344H397.296V181.056H448.236V66.2344Z",
    fill: "#F4F7FA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M413.465 78.917H406.997V173.517H413.465V78.917Z",
    fill: "#BCC3CA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M427.213 78.917H420.474V173.517H427.213V78.917Z",
    fill: "#BCC3CA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M440.688 78.917H433.95V173.517H440.688V78.917Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M413.465 78.917H411.309V173.517H413.465V78.917Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M427.211 78.917H425.055V173.517H427.211V78.917Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M440.957 78.917H438.8V173.517H440.957V78.917Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M448.234 181.05V181.056H397.293L378.965 177.58V165.908C387.456 152.912 384.66 147.505 386.492 137.865C388.281 128.454 384.505 78.8595 395.633 67.3346C396.035 66.9135 396.454 66.5461 396.897 66.2344C396.959 66.3128 397.021 66.3913 397.083 66.4718C397.153 66.5605 397.223 66.6493 397.293 66.7401C403.083 74.1055 405.734 77.623 406.997 81.3615C408.227 85.0049 408.134 88.8569 408.334 96.6888C408.582 106.321 408.53 114.7 411.309 120.469C411.891 121.685 412.601 122.783 413.466 123.754C415.145 125.642 417.408 127.044 420.472 127.864C420.813 127.957 421.159 128.041 421.518 128.118C422.713 128.371 423.893 128.768 425.055 129.292C425.783 129.618 426.501 129.994 427.211 130.423C429.59 131.846 431.864 133.798 433.95 136.174C435.712 138.179 437.344 140.483 438.801 143.015C439.467 144.174 440.096 145.381 440.686 146.632C440.777 146.824 440.866 147.016 440.957 147.212C444.256 154.423 446.212 162.975 446.041 171.68C445.964 175.47 446.806 178.521 448.234 181.05Z",
    fill: "#BCC3CA"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M449.666 157.726H340.661V207.621H449.666V157.726Z",
    fill: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M429.144 189.685C420.951 187.189 411.12 188.436 404.565 184.691C384.415 175.922 363.402 159.455 340.661 158.111V207.619H449.666V202.766C443.055 197.88 436.566 192.981 429.144 189.685Z",
    fill: "#BCC3CA"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M341.372 207.394L322.957 202.376V164.084L340.918 157.903L341.372 207.394Z",
    fill: "#BCC3CA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M437.375 187.253H414.945V207.591H437.375V187.253Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M437.375 187.253H435.219V207.591H437.375V187.253Z",
    fill: "#BCC3CA"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M395.655 187.253H373.225V207.591H395.655V187.253Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M395.303 187.253H393.146V207.591H395.303V187.253Z",
    fill: "#BCC3CA"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M329.667 320.833V333.146C329.667 334.292 330.534 335.252 331.673 335.368L457.688 347.316L474.65 358.545L498.073 327.375L329.667 320.833Z",
    fill: "#51566D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M426.258 337.758V348.78C426.258 349.705 426.928 350.491 427.84 350.638L458.094 355.499L457.215 337.732L428.259 335.88C427.176 335.81 426.258 336.671 426.258 337.758Z",
    fill: "url(#paint0_linear_1720_114865)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M342.433 326.514C342.33 326.514 342.229 326.522 342.128 326.532L340.528 326.514L340.539 327.218C338.989 328.429 337.912 331.082 337.912 334.16C337.912 337.238 339.074 340.099 340.724 341.238L340.733 341.806H342.435C344.932 341.806 346.956 338.383 346.956 334.16C346.956 329.936 344.932 326.514 342.435 326.514H342.433Z",
    fill: "#404385"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M340.528 341.806C343.025 341.806 345.049 338.383 345.049 334.16C345.049 329.937 343.025 326.514 340.528 326.514C338.032 326.514 336.008 329.937 336.008 334.16C336.008 338.383 338.032 341.806 340.528 341.806Z",
    fill: "#2C307F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M339.893 338.456C341.296 338.456 342.433 336.533 342.433 334.16C342.433 331.788 341.296 329.864 339.893 329.864C338.49 329.864 337.353 331.788 337.353 334.16C337.353 336.533 338.49 338.456 339.893 338.456Z",
    fill: "#D8DEE8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M340.277 338.148C341.468 338.148 342.433 336.363 342.433 334.16C342.433 331.957 341.468 330.172 340.277 330.172C339.086 330.172 338.121 331.957 338.121 334.16C338.121 336.363 339.086 338.148 340.277 338.148Z",
    fill: "url(#paint1_linear_1720_114865)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M353.117 327.375C353.005 327.375 352.894 327.383 352.782 327.395L351.029 327.375L351.039 328.147C349.341 329.476 348.163 332.381 348.163 335.752C348.163 339.123 349.436 342.258 351.243 343.507L351.251 344.129H353.117C355.852 344.129 358.07 340.378 358.07 335.752C358.07 331.126 355.852 327.375 353.117 327.375Z",
    fill: "#404385"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M351.031 344.129C353.767 344.129 355.984 340.378 355.984 335.752C355.984 331.125 353.767 327.375 351.031 327.375C348.295 327.375 346.077 331.125 346.077 335.752C346.077 340.378 348.295 344.129 351.031 344.129Z",
    fill: "#2C307F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M350.333 340.458C351.87 340.458 353.117 338.351 353.117 335.752C353.117 333.152 351.87 331.045 350.333 331.045C348.796 331.045 347.55 333.152 347.55 335.752C347.55 338.351 348.796 340.458 350.333 340.458Z",
    fill: "#D8DEE8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M350.754 340.122C352.059 340.122 353.117 338.165 353.117 335.752C353.117 333.338 352.059 331.382 350.754 331.382C349.449 331.382 348.392 333.338 348.392 335.752C348.392 338.165 349.449 340.122 350.754 340.122Z",
    fill: "url(#paint2_linear_1720_114865)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M364.52 327.375C364.399 327.375 364.277 327.385 364.155 327.397L362.24 327.375L362.251 328.217C360.396 329.668 359.11 332.839 359.11 336.522C359.11 340.204 360.501 343.625 362.474 344.989L362.482 345.668H364.518C367.506 345.668 369.926 341.573 369.926 336.522C369.926 331.47 367.504 327.375 364.518 327.375H364.52Z",
    fill: "#404385"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M362.242 345.668C365.229 345.668 367.65 341.573 367.65 336.522C367.65 331.47 365.229 327.375 362.242 327.375C359.256 327.375 356.835 331.47 356.835 336.522C356.835 341.573 359.256 345.668 362.242 345.668Z",
    fill: "#2C307F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M361.483 341.66C363.162 341.66 364.522 339.359 364.522 336.522C364.522 333.684 363.162 331.384 361.483 331.384C359.805 331.384 358.444 333.684 358.444 336.522C358.444 339.359 359.805 341.66 361.483 341.66Z",
    fill: "#D8DEE8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M364.52 336.522C364.52 339.156 363.365 341.292 361.941 341.292C360.517 341.292 359.362 339.156 359.362 336.522C359.362 333.888 360.517 331.751 361.941 331.751C363.365 331.751 364.52 333.888 364.52 336.522Z",
    fill: "url(#paint3_linear_1720_114865)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M463.048 333.991C462.848 333.991 462.65 334.006 462.454 334.028L459.332 333.991L459.351 335.366C456.326 337.732 454.228 342.905 454.228 348.91C454.228 354.915 456.495 360.495 459.712 362.72L459.726 363.826H463.048C467.92 363.826 471.869 357.148 471.869 348.91C471.869 340.671 467.92 333.991 463.048 333.991Z",
    fill: "#404385"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M459.332 363.826C464.204 363.826 468.153 357.148 468.153 348.91C468.153 340.672 464.204 333.993 459.332 333.993C454.461 333.993 450.512 340.672 450.512 348.91C450.512 357.148 454.461 363.826 459.332 363.826Z",
    fill: "#243572"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M458.094 357.29C460.831 357.29 463.05 353.538 463.05 348.909C463.05 344.281 460.831 340.528 458.094 340.528C455.357 340.528 453.138 344.281 453.138 348.909C453.138 353.538 455.357 357.29 458.094 357.29Z",
    fill: "#D8DEE8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M458.843 356.689C461.166 356.689 463.048 353.206 463.048 348.909C463.048 344.612 461.166 341.129 458.843 341.129C456.521 341.129 454.638 344.612 454.638 348.909C454.638 353.206 456.521 356.689 458.843 356.689Z",
    fill: "url(#paint4_linear_1720_114865)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M322.171 255.288C320.521 255.562 319.312 256.991 319.312 258.665V321.085C319.312 322.901 320.729 324.4 322.543 324.501L439.81 331.047V235.72L322.173 255.29L322.171 255.288Z",
    fill: "#4371BC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M505.938 237.944L439.809 235.719V331.045H509.495V241.623C509.495 239.637 507.923 238.01 505.94 237.944H505.938Z",
    fill: "#438AFE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M544.721 300.886L539.833 288.589L539.689 278.422L544.626 277.433C545.105 277.338 545.406 276.863 545.289 276.389C544.542 273.391 541.81 263.487 537.56 260.215C534.564 257.909 477.747 257.22 477.747 257.22L450.4 258.999C448.252 259.14 446.581 260.923 446.581 263.076V323.702C446.581 325.294 447.796 326.619 449.381 326.757L468.153 328.386L471.869 332.145C471.869 332.145 525.073 336.408 546.306 332.533C547.406 332.333 548.206 331.381 548.206 330.262V303.596C548.206 299.723 544.721 300.883 544.721 300.883V300.886Z",
    fill: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M487.038 304.566C487.038 304.566 486.458 278.228 487.038 267.382C487.319 262.122 484.686 259.053 481.898 257.282C479.301 257.24 477.745 257.222 477.745 257.222L450.398 259.001C448.25 259.141 446.579 260.925 446.579 263.078V323.704C446.579 325.296 447.794 326.621 449.379 326.759L468.151 328.388L471.867 332.147C471.867 332.147 480.627 332.849 492.456 333.425V310.959L487.036 304.568L487.038 304.566Z",
    fill: "#D6DCE7"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M547.602 337.259L545.497 336.522V332.255C545.497 331.105 544.564 330.172 543.415 330.172H477.528C475.94 330.172 474.65 331.46 474.65 333.052V358.545C474.65 359.947 475.816 361.07 477.217 361.016L547.767 358.302C549.093 358.25 550.144 357.16 550.144 355.831V340.842C550.144 339.228 549.124 337.791 547.602 337.259Z",
    fill: "#BCC3CA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M539.573 315.354H500.507C499.191 315.354 498.153 316.469 498.244 317.782L500.396 348.47C500.503 350.012 501.811 351.19 503.357 351.139L536.92 350.001C538.385 349.952 539.58 348.804 539.685 347.341L541.837 317.79C541.932 316.475 540.892 315.354 539.573 315.354Z",
    fill: "#414568"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M547.602 337.259L545.497 336.522V332.255C545.497 331.347 544.913 330.575 544.102 330.292L540.093 349.153C539.617 351.399 537.675 353.034 535.381 353.125L504.588 354.322C502.381 354.409 500.377 353.038 499.653 350.951L492.456 330.174H477.526C475.938 330.174 474.648 331.462 474.648 333.054V358.548C474.648 359.949 475.814 361.072 477.215 361.019L547.765 358.304C549.091 358.252 550.142 357.163 550.142 355.833V340.844C550.142 339.23 549.122 337.793 547.6 337.261L547.602 337.259Z",
    fill: "#BCC3CA"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M495.749 352.595L488.423 352.962C483.873 353.189 479.965 349.766 479.59 345.225L479.295 341.662H493.962C494.949 341.662 495.749 342.463 495.749 343.45V352.597V352.595Z",
    fill: "url(#paint5_linear_1720_114865)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M543.011 343.169L541.841 351.139C541.841 351.139 549.564 350.869 549.372 341.127L544.579 341.654C543.772 341.742 543.128 342.364 543.011 343.167V343.169Z",
    fill: "url(#paint6_linear_1720_114865)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M488.713 304.695C487.57 304.695 486.44 304.325 485.517 303.65L482.503 301.441C481.395 300.628 480.733 299.323 480.733 297.949V280.392C480.733 279.601 481.079 278.854 481.684 278.344C482.288 277.836 483.085 277.62 483.861 277.754L486.815 278.264H539.815L539.844 278.385L544.884 300.882L544.878 300.915L544.321 303.704H544.193L488.808 304.691C488.777 304.691 488.744 304.691 488.713 304.691V304.695ZM483.405 278.034C482.854 278.034 482.317 278.229 481.89 278.588C481.358 279.036 481.05 279.694 481.05 280.392V297.949C481.05 299.222 481.663 300.432 482.691 301.183L485.705 303.392C486.574 304.028 487.639 304.377 488.713 304.377C488.742 304.377 488.773 304.377 488.802 304.377L544.059 303.394L544.558 300.89L539.561 278.584H486.788L483.807 278.072C483.673 278.049 483.539 278.037 483.405 278.037V278.034Z",
    fill: "#808080"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M539.689 278.42H486.788L483.834 277.91C482.297 277.646 480.892 278.829 480.892 280.389V297.946C480.892 299.275 481.525 300.524 482.596 301.309L485.61 303.518C486.535 304.195 487.657 304.552 488.804 304.531L544.187 303.546L544.719 300.884L539.687 278.418L539.689 278.42Z",
    fill: "#122C58"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M506.806 272.32H502.306C501.625 272.32 501.072 272.873 501.072 273.555V275.444C501.072 276.125 501.625 276.678 502.306 276.678H506.806C507.488 276.678 508.04 276.125 508.04 275.444V273.555C508.04 272.873 507.488 272.32 506.806 272.32Z",
    fill: "#BCC3CA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M533.229 272.32H528.729C528.047 272.32 527.495 272.873 527.495 273.555V275.444C527.495 276.125 528.047 276.678 528.729 276.678H533.229C533.91 276.678 534.463 276.125 534.463 275.444V273.555C534.463 272.873 533.91 272.32 533.229 272.32Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M523.139 290.913C509.489 285.69 496.647 292.199 490.764 285.104C489.173 283.184 488.532 280.798 488.383 278.422H486.79L483.836 277.912C482.299 277.648 480.894 278.831 480.894 280.391V297.948C480.894 299.277 481.527 300.526 482.598 301.311L485.612 303.519C486.537 304.197 487.659 304.554 488.806 304.533L538.975 303.641C533.303 295.993 527.544 292.597 523.139 290.913Z",
    fill: "#D9DADB"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2016 378.672L25.9437 447.186L198.053 450.103L231.765 349.506L65.8559 356.653L66.5017 359.557L26.2016 378.672Z",
    fill: "url(#paint7_linear_1720_114865)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2017 378.672L66.1798 355.255L231.765 349.506L194.972 373.2L26.2017 378.672Z",
    fill: "#B7B9BB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141 384.401L198.007 377.198V371.431L23.3832 378.73L23.4141 384.401Z",
    fill: "url(#paint8_linear_1720_114865)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M231.764 349.506L261.624 378.491L262.144 442.333L198.052 450.103L198.057 371.431L231.764 349.506Z",
    fill: "url(#paint9_linear_1720_114865)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M198.007 377.929L231.934 354.126L262.177 382.729L262.151 378.567L231.793 349.518L198.007 371.431V377.929Z",
    fill: "url(#paint10_linear_1720_114865)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M256.443 431.485L256.078 382.172L240.773 380.725L241.058 432.767L256.443 431.485Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M242.102 430.702L255.366 429.808L255.03 383.872L241.833 382.66L242.102 430.702Z",
    fill: "#ECC711"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M249.263 432.038L248.935 381.48L247.615 381.348L247.937 432.131L249.263 432.038Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M240.969 416.783L256.332 416.343L256.32 414.552L240.958 414.89L240.969 416.783Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M240.868 398.174L256.202 398.71L256.188 396.925L240.857 396.291L240.868 398.174Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M229.216 433.652L229.004 379.576L210.102 377.743L210.187 435.11L229.216 433.652Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M211.998 432.936L227.898 431.822L227.708 381.426L211.907 379.991L211.998 432.936Z",
    fill: "#ECC711"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M220.848 434.319L220.689 378.778L219.135 378.627L219.284 434.439L220.848 434.319Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M210.162 417.483L229.15 417.041L229.142 415.076L210.158 415.398L210.162 417.483Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M210.131 396.97L229.074 397.705L229.066 395.748L210.127 394.893L210.131 396.97Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M109.833 397.531L109.585 448.234L166.777 448.95L167.32 396.408L109.833 397.531Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M111.114 399.216L110.871 448.249L165.125 448.931L165.642 398.209L111.114 399.216Z",
    fill: "#9E9E9E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M107.497 401.27L169.501 400.205L169.571 393.411L107.526 394.735L107.497 401.27Z",
    fill: "#D8DEE8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M108.242 406.654L168.61 405.822L168.667 400.22L108.269 401.258L108.242 406.654Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M108.261 402.96L168.649 401.988L168.657 401.103L108.265 402.11L108.261 402.96Z",
    fill: "#D8DEE8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M108.25 404.95L168.626 404.052L168.636 403.167L108.254 404.098L108.25 404.95Z",
    fill: "#D8DEE8"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M36.745 398.96L36.8461 447.322L88.8099 447.972L88.9543 397.94L36.745 398.96Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9232 400.566L38.0139 447.337L87.5616 447.958L87.6957 399.647L37.9232 400.566Z",
    fill: "#9E9E9E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6425 402.523L91.2074 401.551L91.2281 395.081L34.6301 396.289L34.6425 402.523Z",
    fill: "#D8DEE8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5917 407.655L90.1841 406.901L90.2006 401.567L35.5793 402.507L35.5917 407.655Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7588 404.119L90.2769 403.246L90.3202 402.399L35.7567 403.305L35.7588 404.119Z",
    fill: "#D8DEE8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7629 406.013L90.2728 405.21L90.3161 404.364L35.7609 405.202L35.7629 406.013Z",
    fill: "#D8DEE8"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9026 491.116L124.177 493.983V434.264L64.9026 437.131V491.116Z",
    fill: "url(#paint11_linear_1720_114865)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M124.177 493.983L145.433 489.896V438.076L124.177 434.264V493.983Z",
    fill: "#E9B648"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M105.176 435.279V444.616L89.3092 445.31V436.239L105.176 435.279Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M140.885 437.261L131.982 435.663V444.859L140.885 445.826V437.261Z",
    fill: "white"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5765 494.15L73.4426 496.176V453.996L31.5765 456.021V494.15Z",
    fill: "url(#paint12_linear_1720_114865)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4426 496.176L88.455 493.29V456.688L73.4426 453.996V496.176Z",
    fill: "#FFC444"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M60.023 454.712V461.307L48.8152 461.797V455.391L60.023 454.712Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2425 456.111L78.9536 454.984V461.479L85.2425 462.162V456.111Z",
    fill: "white"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M82.127 500.513L112.152 501.966V471.714L82.127 473.167V500.513Z",
    fill: "url(#paint13_linear_1720_114865)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M112.152 501.966L122.918 499.895V473.646L112.152 471.714V501.966Z",
    fill: "#FFC444"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M102.527 472.228V476.957L94.4901 477.31V472.715L102.527 472.228Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M120.615 473.233L116.105 472.424V477.081L120.615 477.57V473.233Z",
    fill: "white"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M258.043 538.601L285.567 537.474L277.945 519.611L260.213 520.658L255.468 528.422L258.043 538.601Z",
    fill: "url(#paint14_linear_1720_114865)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M232.22 510.207C232.037 510.207 231.855 510.219 231.676 510.238L228.816 510.207L228.833 511.328C226.062 513.258 224.139 517.48 224.139 522.38C224.139 527.281 226.216 531.835 229.165 533.651L229.179 534.555H232.223C236.685 534.555 240.304 529.106 240.304 522.382C240.304 515.659 236.685 510.209 232.223 510.209L232.22 510.207Z",
    fill: "#404385"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M228.816 534.553C233.28 534.553 236.898 529.103 236.898 522.38C236.898 515.657 233.28 510.207 228.816 510.207C224.353 510.207 220.734 515.657 220.734 522.38C220.734 529.103 224.353 534.553 228.816 534.553Z",
    fill: "#2C307F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M311.199 519.45C310.974 519.45 310.753 519.465 310.532 519.485L307.029 519.45L307.05 520.707C303.655 522.871 301.299 527.598 301.299 533.089C301.299 538.58 303.845 543.681 307.456 545.714L307.473 546.726H311.201C316.669 546.726 321.103 540.62 321.103 533.087C321.103 525.554 316.669 519.448 311.201 519.448L311.199 519.45Z",
    fill: "#404385"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M307.029 546.728C312.498 546.728 316.931 540.622 316.931 533.089C316.931 525.557 312.498 519.45 307.029 519.45C301.56 519.45 297.127 525.557 297.127 533.089C297.127 540.622 301.56 546.728 307.029 546.728Z",
    fill: "#2C307F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M273.546 525.783C273.325 525.783 273.107 525.798 272.89 525.818L269.44 525.783L269.461 527.071C266.118 529.288 263.799 534.137 263.799 539.765C263.799 545.392 266.306 550.623 269.861 552.708L269.877 553.746H273.548C278.931 553.746 283.295 547.487 283.295 539.765C283.295 532.042 278.931 525.783 273.548 525.783H273.546Z",
    fill: "#404385"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M269.44 553.746C274.823 553.746 279.187 547.486 279.187 539.765C279.187 532.043 274.823 525.783 269.44 525.783C264.057 525.783 259.693 532.043 259.693 539.765C259.693 547.486 264.057 553.746 269.44 553.746Z",
    fill: "url(#paint15_linear_1720_114865)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M268.07 547.619C271.094 547.619 273.546 544.103 273.546 539.765C273.546 535.427 271.094 531.91 268.07 531.91C265.046 531.91 262.594 535.427 262.594 539.765C262.594 544.103 265.046 547.619 268.07 547.619Z",
    fill: "#D8DEE8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M268.897 547.058C271.465 547.058 273.546 543.793 273.546 539.765C273.546 535.737 271.465 532.472 268.897 532.472C266.33 532.472 264.249 535.737 264.249 539.765C264.249 543.793 266.33 547.058 268.897 547.058Z",
    fill: "url(#paint16_linear_1720_114865)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M176.332 510.207V524.76C176.332 528.559 179.656 531.502 183.426 531.038L218.797 526.692V510.207H176.334H176.332Z",
    fill: "#2C307F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M192.257 508.186L201.967 523.284C203.355 525.443 205.633 526.869 208.179 527.175L240.302 531.037L242.76 514.785L192.255 508.188L192.257 508.186Z",
    fill: "#51566D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M194.495 515.541C194.312 515.541 194.13 515.553 193.951 515.572L191.091 515.541L191.107 516.662C188.336 518.592 186.414 522.813 186.414 527.714C186.414 532.615 188.491 537.169 191.44 538.985L191.454 539.889H194.497C198.96 539.889 202.579 534.44 202.579 527.716C202.579 520.993 198.96 515.543 194.497 515.543L194.495 515.541Z",
    fill: "#404385"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M191.091 539.887C195.554 539.887 199.173 534.437 199.173 527.714C199.173 520.991 195.554 515.541 191.091 515.541C186.627 515.541 183.009 520.991 183.009 527.714C183.009 534.437 186.627 539.887 191.091 539.887Z",
    fill: "url(#paint17_linear_1720_114865)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M189.954 534.553C192.462 534.553 194.495 531.491 194.495 527.714C194.495 523.937 192.462 520.875 189.954 520.875C187.446 520.875 185.413 523.937 185.413 527.714C185.413 531.491 187.446 534.553 189.954 534.553Z",
    fill: "#D8DEE8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M190.641 534.064C192.77 534.064 194.495 531.221 194.495 527.714C194.495 524.207 192.77 521.364 190.641 521.364C188.513 521.364 186.787 524.207 186.787 527.714C186.787 531.221 188.513 534.064 190.641 534.064Z",
    fill: "url(#paint18_linear_1720_114865)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M229.571 519.611L163.59 510.469C162.504 510.318 161.695 509.389 161.695 508.293V450.132C161.695 448.945 162.638 447.972 163.823 447.935L229.571 445.908V519.609V519.611Z",
    fill: "#4371BC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M281.364 515.541L229.571 519.611V445.91L278.791 448.509C280.233 448.586 281.364 449.777 281.364 451.222V515.541Z",
    fill: "#438AFE"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M239.582 476.406C237.796 484.43 233.628 507.579 238.278 532.456C238.625 534.308 240.111 535.736 241.97 536.033L258.04 538.601C258.04 538.601 258.201 523.379 265.922 522.38C273.643 521.381 280.881 528.622 281.364 541.175C281.364 541.175 298.091 543.428 323.343 537.635C323.343 537.635 326.721 536.911 328.169 533.09L327.028 515.582C326.936 514.146 326.269 512.806 325.18 511.865L310.316 499.014C310.316 499.014 296.805 479.864 292.301 476.163C292.301 476.163 289.889 472.301 270.426 471.817C257.023 471.485 247.794 472.373 243.346 472.959C241.489 473.203 239.989 474.577 239.582 476.406Z",
    fill: "url(#paint19_linear_1720_114865)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M326.174 513.01L325.436 513.819C325.757 522.83 327.709 526.017 311.201 527.716C294.693 529.415 295.198 515.543 295.198 515.543L273.548 506.096L255.47 477.613C251.882 474.721 245.611 473.931 241.361 473.747C240.48 474.37 239.832 475.304 239.586 476.408C237.8 484.432 233.632 507.581 238.282 532.457C238.629 534.309 240.115 535.738 241.974 536.035L258.045 538.603C258.045 538.603 258.205 523.381 265.926 522.382C273.647 521.383 280.885 528.624 281.368 541.177C281.368 541.177 298.095 543.429 323.347 537.637C323.347 537.637 326.725 536.912 328.173 533.091L327.032 515.584C326.973 514.659 326.671 513.776 326.178 513.012L326.174 513.01Z",
    fill: "url(#paint20_linear_1720_114865)"
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M273.325 501.939C273.911 502.901 275.005 503.432 276.123 503.294L310.404 499.089L310.316 499.012C310.316 499.012 299.104 483.121 293.702 477.494L262.091 479.397C261.001 479.463 260.374 480.665 260.941 481.596L273.323 501.939H273.325Z",
    fill: "url(#paint21_linear_1720_114865)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M293.737 491.259C284.403 487.587 276.647 491.938 270.228 486.804C267.758 484.829 266.287 482.087 265.419 479.197L262.091 479.397C261.001 479.464 260.374 480.665 260.941 481.596L273.323 501.939C273.909 502.901 275.003 503.432 276.121 503.294L304.567 499.805C300.831 494.948 296.985 492.537 293.735 491.259H293.737Z",
    fill: "white"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M324.034 515.332C323.999 515.02 323.737 514.783 323.424 514.787C314.882 514.861 304.14 516.659 300.583 517.297C299.913 517.417 299.471 518.071 299.626 518.736C300.321 521.705 301.475 523.713 302.325 524.879C302.902 525.672 303.79 526.172 304.768 526.248C307.456 526.459 313.417 526.818 316.307 526.13C318.878 525.517 321.34 524.297 322.662 523.573C323.432 523.152 323.977 522.402 324.111 521.533C324.435 519.436 324.171 516.529 324.034 515.332Z",
    fill: "url(#paint22_linear_1720_114865)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M282.234 516.156C281.995 515.669 282.224 515.081 282.734 514.893C283.489 514.614 284.523 514.292 285.123 514.362C285.911 514.455 292.569 516.185 295.617 516.984C296.558 517.23 297.208 518.103 297.144 519.073C297.008 521.148 296.224 524.434 292.664 524.801C287.721 525.313 284.597 520.951 282.234 516.156Z",
    fill: "#3F4581"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M314.257 528.422C301.297 530.233 298.669 525.784 298.669 525.784C295.602 526.24 291.243 525.64 288.773 525.208C287.832 525.045 286.918 525.491 286.392 526.29C285.998 526.886 285.282 527.491 283.978 527.714C281.851 528.082 278.23 527.27 276.457 526.814C279.038 530.358 280.846 534.954 281.083 541.155C281.083 541.155 298.093 543.427 323.345 537.633C323.345 537.633 326.723 536.908 328.171 533.087L327.427 521.67C326.104 523.695 322.642 527.25 314.257 528.42V528.422Z",
    fill: "url(#paint23_linear_1720_114865)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.18 530.674C291.746 530.535 290.523 531.683 290.556 533.124C290.624 536.204 290.308 539.426 290.032 541.604C297.369 541.62 308.973 540.931 323.345 537.634C323.345 537.634 326.723 536.91 328.171 533.089L327.738 526.436C317.385 532.308 299.956 531.332 293.182 530.676L293.18 530.674Z",
    fill: "#737678",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M245.11 481.061L249.765 482.188C251.287 482.558 252.618 483.476 253.503 484.768L265.029 501.588C265.815 502.736 264.8 504.257 263.438 503.968L243.467 499.741C242.663 499.571 242.075 498.88 242.04 498.058C241.916 495.176 241.782 488.344 242.91 482.485C243.106 481.47 244.103 480.815 245.108 481.059L245.11 481.061Z",
    fill: "url(#paint24_linear_1720_114865)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M200.434 108.301H189.7V110.41H200.434V108.301Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M200.434 134.515H189.7V136.625H200.434V134.515Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M200.434 160.729H189.7V162.839H200.434V160.729Z",
    fill: "#BCC3CA"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M178.761 94.042V220.899L161.675 217.053V106.087L178.761 94.042Z",
    fill: "#BCC3CA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M232.208 94.3438H178.761V220.897H232.208V94.3438Z",
    fill: "#D8DEE8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 109.411H188.398V129.298H198.913V109.411Z",
    fill: "#BCC3CA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M213.589 109.411H202.856V129.298H213.589V109.411Z",
    fill: "#BCC3CA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M228.046 109.411H217.532V129.298H228.046V109.411Z",
    fill: "#BCC3CA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 135.625H188.398V155.512H198.913V135.625Z",
    fill: "#BCC3CA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M213.589 135.625H202.856V155.512H213.589V135.625Z",
    fill: "#BCC3CA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M228.046 135.625H217.532V155.512H228.046V135.625Z",
    fill: "#BCC3CA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 161.84H188.398V181.727H198.913V161.84Z",
    fill: "#BCC3CA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M213.589 161.84H202.856V181.727H213.589V161.84Z",
    fill: "#BCC3CA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M228.046 161.84H217.532V181.727H228.046V161.84Z",
    fill: "#BCC3CA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 188.054H188.398V207.941H198.913V188.054Z",
    fill: "#BCC3CA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M213.589 188.054H202.856V207.941H213.589V188.054Z",
    fill: "#BCC3CA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M228.046 188.054H217.532V207.941H228.046V188.054Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 109.411H188.398V111.521H198.913V109.411Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 135.625H188.398V137.735H198.913V135.625Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 161.84H188.398V163.95H198.913V161.84Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 188.054H188.398V190.163H198.913V188.054Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M232.208 218.798V220.897H178.761L161.675 217.051V198.272C162.818 194.268 164.198 190.368 165.836 187.148C172.117 174.793 170.07 169.771 171.385 160.731C172.699 151.692 169.779 102.679 178.761 94.3418C187.156 108.303 186.575 107.7 186.865 122.567C187.02 130.518 187.01 137.551 188.398 142.774C189.603 147.311 191.867 150.478 196.212 151.694C197.126 151.95 198.028 152.356 198.913 152.901C201.74 154.633 204.395 157.765 206.648 161.838C209.609 167.186 211.881 174.159 212.939 181.725C213.23 183.796 213.43 185.914 213.527 188.052C213.56 188.762 213.583 189.481 213.591 190.197C213.599 190.82 213.599 191.444 213.591 192.067C213.587 192.288 213.587 192.505 213.591 192.717C213.632 198.124 215.254 201.85 217.534 204.709C218.5 205.921 219.585 206.975 220.72 207.935C225.253 211.775 230.566 214.091 232.21 218.791L232.208 218.798Z",
    fill: "#BCC3CA"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M129.124 105.949V199.176L114.23 196.353V114.803L127.775 106.752L128.953 106.05L129.124 105.949Z",
    fill: "#BCC3CA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M170.524 105.856H129.124V199.174H170.524V105.856Z",
    fill: "#F4F7FA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M142.268 116.163H137.01V193.048H142.268V116.163Z",
    fill: "#BCC3CA"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M153.438 116.163H147.962V193.048H153.438V116.163Z",
    fill: "#BCC3CA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M164.392 116.163H158.916V193.048H164.392V116.163Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M142.268 116.163H140.516V193.048H142.268V116.163Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M153.438 116.163H151.686V193.048H153.438V116.163Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M164.609 116.163H162.857V193.048H164.609V116.163Z",
    fill: "#BCC3CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M170.524 199.17V199.177H129.124L114.23 196.353V186.867C121.129 176.304 118.858 171.911 120.347 164.075C121.802 156.425 118.734 116.12 127.775 106.752C128.101 106.41 128.444 106.112 128.803 105.858C128.852 105.922 128.904 105.986 128.953 106.05C129.011 106.123 129.067 106.195 129.124 106.267C133.829 112.254 135.985 115.111 137.01 118.151C138.009 121.111 137.935 124.243 138.098 130.609C138.3 138.437 138.259 145.247 140.516 149.935C140.988 150.924 141.566 151.816 142.268 152.604C143.631 154.14 145.472 155.277 147.962 155.944C148.239 156.018 148.521 156.089 148.812 156.151C149.782 156.357 150.741 156.679 151.686 157.106C152.279 157.371 152.862 157.678 153.438 158.025C155.371 159.181 157.218 160.768 158.914 162.699C160.346 164.327 161.673 166.2 162.857 168.258C163.398 169.199 163.911 170.179 164.39 171.197C164.464 171.354 164.537 171.509 164.609 171.668C167.289 177.528 168.88 184.479 168.739 191.555C168.678 194.635 169.363 197.114 170.522 199.17H170.524Z",
    fill: "#BCC3CA"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M171.688 180.214H83.0967V220.765H171.688V180.214Z",
    fill: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M155.01 206.188C148.352 204.159 140.361 205.175 135.034 202.13C118.657 195.002 101.58 181.619 83.0967 180.527V220.764H171.69V216.82C166.317 212.848 161.043 208.868 155.012 206.188H155.01Z",
    fill: "#BCC3CA"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6765 220.581L68.7073 216.504V185.381L83.3051 180.358L83.6765 220.581Z",
    fill: "#BCC3CA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M161.7 204.213H143.47V220.742H161.7V204.213Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M161.697 204.213H159.946V220.742H161.697V204.213Z",
    fill: "#BCC3CA"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M127.792 204.213H109.562V220.742H127.792V204.213Z",
    fill: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M127.505 204.213H125.753V220.742H127.505V204.213Z",
    fill: "#BCC3CA"
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M283.398 221.454L203.722 207.435L208.113 163.08H270.643L283.398 221.454Z",
    fill: "#BFC8D6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M255.185 191.555C242.886 182.464 226.421 185.715 220.889 174.817C219.098 171.288 218.945 167.244 219.779 163.082H208.115L203.724 207.437L269.432 218.997C267.026 204.248 261.406 196.152 255.187 191.555H255.185Z",
    fill: "url(#paint25_linear_1720_114865)"
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M242.692 157.659H241.419V164.449H242.692V157.659Z",
    fill: "#51566D"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M247.419 157.659H246.146V164.449H247.419V157.659Z",
    fill: "#51566D"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M252.146 157.659H250.873V164.449H252.146V157.659Z",
    fill: "#51566D"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M256.871 157.659H255.598V164.449H256.871V157.659Z",
    fill: "#51566D"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M266.325 157.659H265.051V164.449H266.325V157.659Z",
    fill: "#51566D"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M261.598 157.659H260.324V164.449H261.598V157.659Z",
    fill: "#51566D"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M271.051 157.659H269.778V164.449H271.051V157.659Z",
    fill: "#51566D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M275.779 157.659H274.505V164.449H275.779V157.659Z",
    fill: "#51566D"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M275.776 156.613H203.605V158.077H275.776V156.613Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M204.878 157.659H203.605V164.449H204.878V157.659Z",
    fill: "url(#paint26_linear_1720_114865)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M209.605 157.659H208.332V164.449H209.605V157.659Z",
    fill: "url(#paint27_linear_1720_114865)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M214.332 157.659H213.059V164.449H214.332V157.659Z",
    fill: "url(#paint28_linear_1720_114865)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M219.059 157.659H217.786V164.449H219.059V157.659Z",
    fill: "url(#paint29_linear_1720_114865)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M223.786 157.659H222.513V164.449H223.786V157.659Z",
    fill: "url(#paint30_linear_1720_114865)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M228.511 157.659H227.238V164.449H228.511V157.659Z",
    fill: "url(#paint31_linear_1720_114865)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M233.238 157.659H231.965V164.449H233.238V157.659Z",
    fill: "url(#paint32_linear_1720_114865)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M237.965 157.659H236.692V164.449H237.965V157.659Z",
    fill: "url(#paint33_linear_1720_114865)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M275.776 161.216H203.605V167.681H275.776V161.216Z",
    fill: "#2A374E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M249.265 182.41H184.082V214.132H249.265V182.41Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M246.564 184.31H186.785V211.74H246.564V184.31Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M193.367 184.31H190.606V211.74H193.367V184.31Z",
    fill: "#D8DEE8"
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M193.476 184.31H191.636V211.74H193.476V184.31Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M200.405 184.31H197.644V211.74H200.405V184.31Z",
    fill: "#D8DEE8"
  }))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M200.514 184.31H198.674V211.74H200.514V184.31Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M207.443 184.31H204.682V211.74H207.443V184.31Z",
    fill: "#D8DEE8"
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M207.552 184.31H205.711V211.74H207.552V184.31Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M214.48 184.31H211.72V211.74H214.48V184.31Z",
    fill: "#D8DEE8"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M214.59 184.31H212.749V211.74H214.59V184.31Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M221.518 184.31H218.758V211.74H221.518V184.31Z",
    fill: "#D8DEE8"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M221.628 184.31H219.787V211.74H221.628V184.31Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M228.558 184.31H225.797V211.74H228.558V184.31Z",
    fill: "#D8DEE8"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M228.665 184.31H226.825V211.74H228.665V184.31Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M235.596 184.31H232.835V211.74H235.596V184.31Z",
    fill: "#D8DEE8"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M235.703 184.31H233.863V211.74H235.703V184.31Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M242.634 184.31H239.873V211.74H242.634V184.31Z",
    fill: "#D8DEE8"
  }))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M242.741 184.31H240.901V211.74H242.741V184.31Z",
    fill: "#D8DEE8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M184.082 182.41H151.47V214.132H184.082V182.41Z",
    fill: "#D8DEE8"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M183.088 213.135V183.407H152.468V213.135H183.088Z",
    fill: "#D8DEE8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M182.654 184.008H167.999V212.534H182.654V184.008Z",
    fill: "#D8DEE8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M167.555 184.008H152.9V212.534H167.555V184.008Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M167.555 192.138H152.9V194.631H167.555V192.138Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M167.555 201.912H152.9V204.406H167.555V201.912Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M182.654 192.138H167.999V194.631H182.654V192.138Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M182.654 201.912H167.999V204.406H182.654V201.912Z",
    fill: "#D8DEE8"
  }))), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M160.21 183.259H159.44V212.982H160.21V183.259Z",
    fill: "#D8DEE8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M159.44 212.982V183.259H159.826L159.44 212.982Z",
    fill: "#BCC3CA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M160.503 182.594H159.149V184.156H160.503V182.594Z",
    fill: "#D8DEE8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M160.503 212.2H159.149V213.763H160.503V212.2Z",
    fill: "#D8DEE8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M170.811 183.259H170.041V212.982H170.811V183.259Z",
    fill: "#D8DEE8"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M170.041 212.982V183.259H170.427L170.041 212.982Z",
    fill: "#BCC3CA"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 182.594H169.75V184.156H171.104V182.594Z",
    fill: "#D8DEE8"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M171.104 212.2H169.75V213.763H171.104V212.2Z",
    fill: "#D8DEE8"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M176.112 183.259H175.342V212.982H176.112V183.259Z",
    fill: "#D8DEE8"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M175.342 212.982V183.259H175.728L175.342 212.982Z",
    fill: "#BCC3CA"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M176.405 182.594H175.051V184.156H176.405V182.594Z",
    fill: "#D8DEE8"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M176.405 212.2H175.051V213.763H176.405V212.2Z",
    fill: "#D8DEE8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M165.51 183.259H164.741V212.982H165.51V183.259Z",
    fill: "#D8DEE8"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M164.741 212.982V183.259H165.127L164.741 212.982Z",
    fill: "#BCC3CA"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M165.803 182.594H164.45V184.156H165.803V182.594Z",
    fill: "#D8DEE8"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M165.803 212.2H164.45V213.763H165.803V212.2Z",
    fill: "#D8DEE8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M238.456 150.872H173.272V182.594H238.456V150.872Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M235.753 152.771H175.973V180.201H235.753V152.771Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M182.557 152.771H179.797V180.201H182.557V152.771Z",
    fill: "#D8DEE8"
  }))), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M182.665 152.771H180.824V180.201H182.665V152.771Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M189.595 152.771H186.834V180.201H189.595V152.771Z",
    fill: "#D8DEE8"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M189.704 152.771H187.864V180.201H189.704V152.771Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 152.771H193.872V180.201H196.633V152.771Z",
    fill: "#D8DEE8"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M196.742 152.771H194.902V180.201H196.742V152.771Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M203.671 152.771H200.91V180.201H203.671V152.771Z",
    fill: "#D8DEE8"
  }))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M203.78 152.771H201.94V180.201H203.78V152.771Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M210.709 152.771H207.948V180.201H210.709V152.771Z",
    fill: "#D8DEE8"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M210.818 152.771H208.978V180.201H210.818V152.771Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M217.747 152.771H214.986V180.201H217.747V152.771Z",
    fill: "#D8DEE8"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M217.856 152.771H216.015V180.201H217.856V152.771Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M224.784 152.771H222.024V180.201H224.784V152.771Z",
    fill: "#D8DEE8"
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M224.894 152.771H223.053V180.201H224.894V152.771Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M231.822 152.771H229.062V180.201H231.822V152.771Z",
    fill: "#D8DEE8"
  }))), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M231.932 152.771H230.091V180.201H231.932V152.771Z",
    fill: "#D8DEE8"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M173.272 150.872H140.66V182.594H173.272V150.872Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M172.276 181.597V151.869H141.657V181.597H172.276Z",
    fill: "#D8DEE8"
  }))), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M171.843 152.47H157.187V180.996H171.843V152.47Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M156.746 152.47H142.09V180.996H156.746V152.47Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M156.746 160.599H142.09V163.092H156.746V160.599Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M156.746 170.373H142.09V172.867H156.746V170.373Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M171.843 160.599H157.187V163.092H171.843V160.599Z",
    fill: "#D8DEE8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M171.843 170.373H157.187V172.867H171.843V170.373Z",
    fill: "#D8DEE8"
  }))), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M149.4 151.721H148.631V181.444H149.4V151.721Z",
    fill: "#D8DEE8"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M148.631 181.444V151.721H149.017L148.631 181.444Z",
    fill: "#BCC3CA"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M149.691 151.056H148.338V152.618H149.691V151.056Z",
    fill: "#D8DEE8"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M149.691 180.662H148.338V182.225H149.691V180.662Z",
    fill: "#D8DEE8"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M160.001 151.721H159.232V181.444H160.001V151.721Z",
    fill: "#D8DEE8"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M159.232 181.444V151.721H159.618L159.232 181.444Z",
    fill: "#BCC3CA"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M160.292 151.056H158.939V152.618H160.292V151.056Z",
    fill: "#D8DEE8"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M160.292 180.662H158.939V182.225H160.292V180.662Z",
    fill: "#D8DEE8"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M165.302 151.721H164.532V181.444H165.302V151.721Z",
    fill: "#D8DEE8"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M164.532 181.444V151.721H164.916L164.532 181.444Z",
    fill: "#BCC3CA"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M165.593 151.056H164.239V152.618H165.593V151.056Z",
    fill: "#D8DEE8"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M165.593 180.662H164.239V182.225H165.593V180.662Z",
    fill: "#D8DEE8"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M154.701 151.721H153.931V181.444H154.701V151.721Z",
    fill: "#D8DEE8"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M153.931 181.444V151.721H154.317L153.931 181.444Z",
    fill: "#BCC3CA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M154.992 151.056H153.638V152.618H154.992V151.056Z",
    fill: "#D8DEE8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M154.992 180.662H153.638V182.225H154.992V180.662Z",
    fill: "#D8DEE8"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M384 63.7722C384 85.4676 351.374 125.058 336.608 141.863C332.934 146.046 326.066 146.046 322.392 141.863C307.626 125.058 275 85.4676 275 63.7722C275 35.7313 299.4 13 329.5 13C359.6 13 384 35.7313 384 63.7722Z",
    fill: "#ECC711"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M350.993 83.7952C362.863 72.7369 362.863 54.808 350.993 43.7498C339.123 32.6915 319.878 32.6915 308.007 43.7497C296.137 54.808 296.137 72.7369 308.007 83.7952C319.878 94.8534 339.123 94.8534 350.993 83.7952Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M329.26 121.017C332.717 99.8041 347.754 93.0135 345.174 72.9833C342.197 49.8826 320.241 43.7308 319.712 23.1712C319.626 19.8613 320.109 16.6693 321.021 13.6133C294.95 17.4081 275.001 38.4188 275.001 63.7731C275.001 85.4685 307.627 125.058 322.393 141.864C324.556 144.326 327.825 145.337 330.897 144.901C328.255 135.61 328.175 127.675 329.26 121.018V121.017Z",
    fill: "#F6F3FE"
  }))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M527 424.02C527 450.094 487.789 497.675 470.043 517.872C465.627 522.899 457.373 522.899 452.957 517.872C435.211 497.675 396 450.094 396 424.02C396 390.319 425.325 363 461.5 363C497.675 363 527 390.319 527 424.02Z",
    fill: "#ECC711"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M487.331 448.085C501.597 434.794 501.597 413.247 487.331 399.957C473.065 386.666 449.935 386.666 435.669 399.957C421.403 413.247 421.403 434.794 435.669 448.085C449.935 461.375 473.065 461.375 487.331 448.085Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M461.211 492.819C465.366 467.324 483.438 459.163 480.337 435.09C476.759 407.327 450.372 399.933 449.736 375.224C449.634 371.246 450.214 367.41 451.31 363.737C419.976 368.298 396.002 393.549 396.002 424.021C396.002 450.095 435.212 497.676 452.958 517.874C455.558 520.832 459.487 522.047 463.179 521.523C460.004 510.357 459.907 500.821 461.211 492.82V492.819Z",
    fill: "#F6F3FE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1720_114865",
    x1: 426.258,
    y1: 345.687,
    x2: 458.094,
    y2: 345.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1720_114865",
    x1: 344.816,
    y1: 334.771,
    x2: 337.755,
    y2: 333.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1720_114865",
    x1: 355.727,
    y1: 336.421,
    x2: 347.991,
    y2: 335.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1720_114865",
    x1: 367.372,
    y1: 337.253,
    x2: 358.924,
    y2: 336.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1720_114865",
    x1: 467.697,
    y1: 350.1,
    x2: 453.92,
    y2: 348.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1720_114865",
    x1: 491.683,
    y1: 332.631,
    x2: 470.178,
    y2: 407.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1720_114865",
    x1: 544.878,
    y1: 347.906,
    x2: 523.374,
    y2: 422.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1720_114865",
    x1: 231.765,
    y1: 399.804,
    x2: 25.9437,
    y2: 399.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1720_114865",
    x1: 111.013,
    y1: 388.1,
    x2: 111.521,
    y2: 405.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1720_114865",
    x1: 262.144,
    y1: -0.0000937891,
    x2: 198.052,
    y2: -0.0000937891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1720_114865",
    x1: 233.108,
    y1: 441.102,
    x2: 230.057,
    y2: 377.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1720_114865",
    x1: 104.819,
    y1: 440.304,
    x2: 60.4606,
    y2: 549.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1720_114865",
    x1: 59.7692,
    y1: 458.261,
    x2: 28.4389,
    y2: 535.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1720_114865",
    x1: 102.345,
    y1: 474.773,
    x2: 79.8758,
    y2: 529.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1720_114865",
    x1: 255.468,
    y1: 529.105,
    x2: 285.567,
    y2: 529.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1720_114865",
    x1: 259.691,
    y1: 539.765,
    x2: 279.187,
    y2: 539.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B307F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1720_114865",
    x1: 275.523,
    y1: 539.046,
    x2: 266.597,
    y2: 540.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1720_114865",
    x1: 183.007,
    y1: 527.714,
    x2: 199.173,
    y2: 527.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C307F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C307F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1720_114865",
    x1: 198.705,
    y1: 528.8,
    x2: 186.157,
    y2: 527.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1720_114865",
    x1: 236.153,
    y1: 506.675,
    x2: 328.169,
    y2: 506.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1720_114865",
    x1: 281.564,
    y1: 508.322,
    x2: 239.072,
    y2: 575.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1720_114865",
    x1: 260.729,
    y1: 490.404,
    x2: 310.404,
    y2: 490.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1720_114865",
    x1: 312.049,
    y1: 511.938,
    x2: 311.566,
    y2: 540.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1720_114865",
    x1: 276.455,
    y1: 531.634,
    x2: 328.169,
    y2: 531.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1720_114865",
    x1: 241.961,
    y1: 492.507,
    x2: 265.305,
    y2: 492.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1720_114865",
    x1: 203.722,
    y1: 191.039,
    x2: 283.398,
    y2: 191.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1720_114865",
    x1: 204.242,
    y1: -0.000723534,
    x2: 204.242,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1720_114865",
    x1: 208.967,
    y1: -0.000723534,
    x2: 208.967,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1720_114865",
    x1: 213.694,
    y1: -0.000723534,
    x2: 213.694,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1720_114865",
    x1: 218.421,
    y1: -0.000723534,
    x2: 218.421,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1720_114865",
    x1: 223.148,
    y1: -0.000723534,
    x2: 223.148,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1720_114865",
    x1: 227.875,
    y1: -0.000723534,
    x2: 227.875,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1720_114865",
    x1: 232.602,
    y1: -0.000723534,
    x2: 232.602,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1720_114865",
    x1: 237.327,
    y1: -0.000723534,
    x2: 237.327,
    y2: -0.000723534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1720_114865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 578,
    height: 578,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroVisualWeb);
export default __webpack_public_path__ + "static/media/hero-visual-web.5a953f24dd48d7b7e0a08e26a502b203.svg";
export { ForwardRef as ReactComponent };